import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2054a63e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app" }
const _hoisted_2 = { class: "left" }

import Tray from "./components/Tray.vue";
import Program from "./components/Program.vue";
import Runner from "@/components/Runner.vue";
import Property from "@/components/Property.vue";
import { onMounted, ref } from "vue";
import importJson from "./utils/importer";
import { useStore } from "./store";
import { useI18n } from "vue-i18n";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { t } = useI18n();

const store = useStore();

const showRight = ref(true);

function toggle() {
  showRight.value = !showRight.value;
}

onMounted(() => {
  try {
    const searchParams = new URLSearchParams(location.search);
    const circuit = searchParams.get("c");
    if (circuit) {
      console.log(circuit);
      const version = searchParams.get("v") ?? "1";
      const snakes = importJson(JSON.parse(atob(circuit)), parseInt(version));
      store.addSnake(...snakes);
    }
  } catch (e) {
    console.error(e);
  }
});

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(Program),
      _createVNode(Tray)
    ]),
    _createElementVNode("div", {
      class: _normalizeClass({ right: true, show: showRight.value })
    }, [
      _createElementVNode("div", {
        class: "toggle-right",
        onClick: toggle
      }, [
        _createVNode(_component_font_awesome_icon, {
          icon: showRight.value ? 'arrow-down' : 'arrow-up'
        }, null, 8, ["icon"]),
        _createTextVNode(" " + _toDisplayString(showRight.value ? _unref(t)("view.hide") : _unref(t)("view.show")), 1)
      ]),
      (showRight.value)
        ? (_openBlock(), _createBlock(Runner, { key: 0 }))
        : _createCommentVNode("", true),
      (showRight.value)
        ? (_openBlock(), _createBlock(Property, { key: 1 }))
        : _createCommentVNode("", true)
    ], 2)
  ]))
}
}

})